import React from 'react';
import PropTypes from 'prop-types';
import Icon, { GLYPHS } from '../../../../../common/icon';

const CustomerMembershipInfoActions = ({ subscription, performAction, disabled }) => {
  const canStart = subscription.availableActions.includes('unpause');
  const canPause = subscription.availableActions.includes('pause');
  const canCancel = subscription.availableActions.includes('cancel');

  return (
    <div className="o-flexbox u-pr">
      <button
        display-if={canStart}
        type="button"
        disabled={disabled}
        onClick={() => performAction('unpause')}
        className="c-btn c-btn--transparent u-co-primary u-type--uppercase u-type--bold u-mr--"
      >
        <Icon glyph={GLYPHS.membershipsStart} className="u-font-color-grey u-mr-" />
        Start
      </button>
      <button
        display-if={canPause}
        type="button"
        disabled={disabled}
        onClick={() => performAction('pause')}
        className="c-btn c-btn--transparent u-co-primary u-type--uppercase u-type--bold u-mr--"
      >
        <Icon glyph={GLYPHS.membershipsPause} className="u-font-color-grey u-mr-" />
        Pause
      </button>
      <button
        display-if={canCancel}
        type="button"
        disabled={disabled}
        onClick={() => performAction('cancel')}
        className="c-btn c-btn--transparent u-co-red u-type--uppercase u-type--bold"
      >
        <Icon glyph={GLYPHS.membershipsCancel} className="u-font-color-grey u-mr-" />
        Cancel
      </button>
    </div>
  );
};

CustomerMembershipInfoActions.propTypes = {
  disabled: PropTypes.bool.isRequired,
  performAction: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
};

export default CustomerMembershipInfoActions;
